import './Button.sass';

import React, { FC } from 'react';

import * as utils from 'utils';
import { ButtonProps } from './Button.interface';

export const Button: FC<ButtonProps> = (props) => {
  const {
    children,
    mode = 'default',
    disabled = false,
    icon = null,
    iconRight = null,
    onClick,
    onTouchStart,
    onPointerDown,
    size = 'normal',
    href = null,
    target = '',
    stretched = false,
    style = {},
    className = '',
    color = '',
    fillColor = '',
    flare = false,
    onTouchEnd,
  } = props;

  const Tag = href ? 'a' : 'div';

  const params = {
    className: utils.classNames({
      Button: true,
      disabled,
      [mode]: true,
      [size]: true,
      stretched,
      [className]: !!className,
      [color ? `${color}Color` : '']: true,
      [fillColor ? `${fillColor}FillColor` : '']: true,
      flare,
    }),
    onClick,
    onTouchStart,
    onTouchEnd,
    onPointerDown,
    style,
  };

  if (href) {
    /* @ts-ignore */
    params.href = href;
    /* @ts-ignore */
    params.target = target;
  }

  return (
    /* @ts-ignore */
    <Tag {...params}>
      {!!icon && <div className="Button__icon">{icon}</div>}
      {!!children && <div className="Button__text">{children}</div>}
      {!!iconRight && <div className="Button__icon">{iconRight}</div>}
    </Tag>
  );
};
